import {getDataWithPromise, Globals, handleAjaxError } from "./BaseDataFns";

// NOTE - these are defined server side in SystemYear.php

export const SystemSurveyStatus =
    {   REASON_UNDEFINED: 0,
        REASON_BEFORE_NEW_ACADEMIC_YEAR_OK: 1,
        REASON_AFTER_NEW_ACADEMIC_YEAR_OK: 2,
        REASON_TOO_EARLY: 3,
        REASON_DONE: 4,

        REASON_SYSTEM_YEAR_INVALID: 10,
    }

export const SystemSurveyGenerateStatus =
    {
        RESULT_ALLOW: true,
        RESULT_DO_NOT_ALLOW: false,
    }

export const getYearSurveyStatus = ( onComplete ) =>
{
    const url = Globals.APIFolder + '/system/generate' ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const generateSurveys = ( data, onComplete ) =>
{
    const url = Globals.APIFolder + '/system/generate' ;

    getDataWithPromise ( url, 'POST', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}




